interface GenerateLiveActivityIdParams {
  workerId: string;
  shiftId: string;
  deviceId: string;
}

export function generateLiveActivityId(params: GenerateLiveActivityIdParams) {
  const { workerId, shiftId, deviceId } = params;
  return `${workerId}-${shiftId}-${deviceId}`;
}
